export const API_LIMIT = 20;
export const BASE_QUERY_KEY = 'INVENTORY';

export const AccessStatus = {
  Initializing: 'Initializing',
  Pending: 'Pending',
  Granting: 'Granting',
  Rejected: 'Rejected',
  Active: 'Active',
  Revoking: 'Revoking',
  Revoked: 'Revoked',
  Failed: 'Failed',
  // BC
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  GRANTED: 'GRANTED',
  REVOKING: 'REVOKING',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AccessStatus = (typeof AccessStatus)[keyof typeof AccessStatus];

type AccessStatusAsProp = AccessStatus | string;

export const isAccessStatusInitializing = (status: AccessStatusAsProp) => status === AccessStatus.Initializing;

export const isAccessStatusPending = (status: AccessStatusAsProp) =>
  status === AccessStatus.Pending || status === AccessStatus.PENDING;

export const isAccessStatusGranting = (status: AccessStatusAsProp) =>
  status === AccessStatus.Granting || status === AccessStatus.APPROVED;

export const isAccessStatusRejected = (status: AccessStatusAsProp) =>
  status === AccessStatus.Rejected || status === AccessStatus.REJECTED;

export const isAccessStatusActive = (status: AccessStatusAsProp) =>
  status === AccessStatus.Active || status === AccessStatus.GRANTED;

export const isAccessStatusRevoking = (status: AccessStatusAsProp) =>
  status === AccessStatus.Revoking || status === AccessStatus.REVOKING;

export const isAccessStatusRevoked = (status: AccessStatusAsProp) =>
  status === AccessStatus.Revoked || status === AccessStatus.EXPIRED;

export const isAccessStatusFailed = (status: AccessStatusAsProp) =>
  status === AccessStatus.Failed || status === AccessStatus.FAILED;

export const accessStatusesWaiting: AccessStatusAsProp[] = [
  AccessStatus.Initializing,
  AccessStatus.Granting,
  AccessStatus.APPROVED,
];

export const isAccessStatusWaiting = (status: AccessStatusAsProp) => accessStatusesWaiting.includes(status);

export const accessStatusesPendingApproval: AccessStatusAsProp[] = [
  // Pending statuses
  AccessStatus.Pending,
  AccessStatus.PENDING,
];
export const isAccessStatusPendingApproval = (status: AccessStatusAsProp) =>
  accessStatusesPendingApproval.includes(status);

export const accessStatusesOpened: AccessStatusAsProp[] = [
  AccessStatus.Initializing,
  // Pending statuses
  AccessStatus.Pending,
  AccessStatus.PENDING,
  // Granting statuses
  AccessStatus.Granting,
  AccessStatus.APPROVED,
  // Active statuses
  AccessStatus.Active,
  AccessStatus.GRANTED,
  // Revoking statuses
  AccessStatus.Revoking,
  AccessStatus.REVOKING,
];

export const isAccessStatusOpen = (status: AccessStatusAsProp) => accessStatusesOpened.includes(status);

export const accessStatusesClosed: AccessStatusAsProp[] = [
  // Rejected statuses
  AccessStatus.Rejected,
  AccessStatus.REJECTED,
  // Revoked statuses
  AccessStatus.Revoked,
  AccessStatus.EXPIRED,
  // Failed statuses
  AccessStatus.Failed,
  AccessStatus.FAILED,
];

export const isAccessStatusClosed = (status: AccessStatusAsProp) => accessStatusesClosed.includes(status);

export const ClientChallengeType = {
  User: 'User',
  Group: 'Group',
  Shift: 'Shift',
  Manager: 'Manager',
  ContextGroup: 'ContextGroup',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ClientChallengeType = (typeof ClientChallengeType)[keyof typeof ClientChallengeType];
